import { render } from "./XIconSolidGift.vue?vue&type=template&id=6c5a6c87"
import script from "./XIconSolidGift.vue?vue&type=script&lang=js"
export * from "./XIconSolidGift.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidGift.vue"]])

export default __exports__